'use strict';

angular.module('TurneroApp').service('menuService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/Menu/:id', { id: '@Id_Menu' }, {
        query: {
            method: 'GET',
            isArray: true
        },
        getMenu: {
            method: 'GET',
            params: {
                id_centro_atencion: 'id_centro_atencion'
            },
            url: portal.getUrlServer() + 'api/Menu/Get_Menu/'
        }
    });
}]);


// WEBPACK FOOTER //
// ./app/components/general/menuService.js